module.exports = __webpack_public_path__ + "img/pausenhof_search-01.a9fa1dab.svg";